import { getServiceUrl } from '../api.config';
import { ApiClientOptions } from '../types/api';
import ApiClient from '../utils/ApiClient';
import qs from '../utils/query';

interface ReferentialUpsertParams {
  retailerId: string;
  name: string;
  active: boolean;
}

export default class OnboardingApi extends ApiClient {
  public constructor(options?: ApiClientOptions) {
    super(getServiceUrl('onboarding'), options);
  }

  listReferentials(retailer_id: string, otherParams: { [k: string]: string }) {
    return this.get(
      // endpoint name is somewhat loosy
      // that's because the ideal name /referentials is already taken (and used)
      '/onboarding/v1/referentials/all',
      qs.stringify({ retailer_id, ...otherParams }, true),
    );
  }

  upsertReferential(params: ReferentialUpsertParams) {
    // using old param name organization_id & code to avoid breaking consumers
    // but these names are wrong regarding what's the endpoint does ...
    const { retailerId: organization_id, name: code, active } = params;
    return this.post('/onboarding/v1/referentials', {
      organization_id,
      code,
      active,
    });
  }
}
